import React, { useEffect, useState } from "react";
import HeaderMenu from "../../_components/HeaderMenu/HeaderSection";
//import "../../_styles/localStyles/typeOfService.css";
import { useTranslation } from "react-i18next";
import { Button } from "../../_components/Button/Button";
import IMAGES from "../../_assets/images/index";
import { Footer } from "../../_components/footer/Footer";
//import { TextInput } from "../../../_components/TextInput/TextInput";
import ProgressBar from "../../_components/progressbar/ProgressBar";
import RadioButton from "../../_components/radioButton/radioButton";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { roofingModel } from "../../_redux/Models/roofing.model";
//import { setOptions } from '../../_redux/actions/rooms.action';
import {
  calculateTotalCost,
  formatPrice,
} from "../../services/utils/utilFunctions";
import { roofingStore } from "../../_redux/actions";
import { useHistory } from "react-router-dom";
import { selectedContractorAtom } from "../../recoil/atoms/contractorAtom";
import { useRecoilState } from "recoil";

export const HaveOwnRoof = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [selectedContractorId] = useRecoilState(selectedContractorAtom);
  const stepValue = 4;

  const state = useSelector((state) =>
    state.buttonReducer && state.buttonReducer.roofingPayload
      ? state.buttonReducer.roofingPayload
      : roofingModel
  );

  const [option, setOption] = useState(""); // To keep the basement size in state
  const price = calculateTotalCost(state.costFor); // To keep the total price in state

  const onSave = (val) => {
    state.haveOwnRoof = val;
    dispatch(roofingStore(state));
    history.push(
      `/contractor-portfolio/${selectedContractorId}/roofing/roof-Material`
    );
  };

  return (
    <div className="insideWrp">
      <div style={{ padding: "0px 20px 20px 20px" }}>
        <div>
          <div className="paint_flex_with_left">
            <label className="paint_header">
              {t("roofing.haveOwnMaterialOrNot")}
            </label>
          </div>
          <div className="padding10"></div>
          <div class="paint_flex_with_left mb-3">
            <label class="paint_other_sub_header ">
              {t("roofing.haveOwnMaterialOrNotTxt")}
            </label>
          </div>

          <div
            onClick={() => {
              setOption("have-roof");
              onSave("have-roof");
            }}
            className={`floor-selection-radio ${
              option === "have-roof" ? "selected" : ""
            }`}
          >
            <div
              // key={index}
              className="width100"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <label className="paintdiv_txt">
                {t("roofing.haveRoofToInstall")}
              </label>
            </div>
          </div>

          <div
            onClick={() => {
              setOption("provide-roof");
              onSave("provide-roof");
            }}
            className={`floor-selection-radio ${
              option === "provide-roof" ? "selected" : ""
            }`}
          >
            <div
              // key={index}
              className="width100"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <label className="paintdiv_txt">
                {t("roofing.contractorProvide")}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
